module.exports = "data:image/gif;base64,R0lGODlhBwAHAJEAADMzM8xmAP4BAgAAACH5BAQUAP8ALAAAAAAHAAcAAAIMhG+hmhu9IAPuoVMAADs="